(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('SiteLocation', SiteLocation);

    SiteLocation.$inject = ['$resource'];

    function SiteLocation ($resource) {
        var resourceUrl =  'api/site-locations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByClinic': {url: 'api/site-locations/by-clinic/:id' ,method: 'GET', isArray: true}
        });
    }
})();
